import {createContext} from 'react'

export const CustomerReportContext = createContext({
  customerGroupData: [],
  isCustomerGroupLoading: false,
  customerGroupFilters: {} as any,
  onCustomerGroupSortingChange: (key: string, order: string) => {},
  handleCustomerGroupReportDateChange: (startDate: any, endDate: any) => {},
  onChangeCustomerGroupFilter: (value: any) => {},

  customerTypeData: [],
  isCustomerTypeLoading: false,
  customerTypeFilters: {} as any,
  onCustomerTypeSortingChange: (key: string, order: string) => {},
  handleCustomerTypeReportDateChange: (startDate: any, endDate: any) => {},

  customerGroups: [] as any[],
  isCustomerGroupsLoading: false,

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,

  customerTypeEntityPerformanceChartData: [] as any,
  isCustomerTypeEntityPerformanceChartDataLoading: false,
  onCustomerTypeEntityPerformanceChartIdChange: (id: string) => {},
  onCustomerTypeEntityPerformanceChartViewChange: (e: any) => {},
  onCustomerTypeEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  customerTypeEntityPerformanceChartFilters: {} as any,
})

export const CouponCodeReportContext = createContext({
  reportData: [],
  isLoading: false,
  filters: {} as any,
  onSearch: (value: string) => {},
  onSortingChange: (key: string, order: string) => {},
  onPageChange: (page: number) => {},
  handleCouponCodeReportDateChange: (startDate: any, endDate: any) => {},
  pagination: {} as any,
  onDownloadCsv: async (payload: any) => '',

  entityPerformanceChartData: [] as any,
  isEntityPerformanceChartDataLoading: false,
  onEntityPerformanceChartIdChange: (id: string) => {},
  onEntityPerformanceChartViewChange: (e: any) => {},
  onEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  entityPerformanceChartFilters: {} as any,
})

export const SalesRepReportContext = createContext({
  salesRepData: [],
  isSalesRepLoading: false,
  salesRepFilters: {} as any,
  onSalesRepSearch: (value: string) => {},
  onSalesRepSortingChange: (key: string, order: string) => {},
  handleSalesRepReportDateChange: (startDate: any, endDate: any) => {},
  onChangeSalesRepTypeFilter: (value: any) => {},
  salesRepTypes: [] as any[],
  isSalesRepDropdownLoading: false,

  
  salesRepEntityPerformanceChartData: [] as any,
  isSalesRepEntityPerformanceChartDataLoading: false,
  onSalesRepEntityPerformanceChartIdChange: (id: string) => {},
  onSalesRepEntityPerformanceChartViewChange: (e: any) => {},
  onSalesRepEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  salesRepEntityPerformanceChartFilters: {} as any,
})

export const SalesRepTypeReportContext = createContext({
  salesRepTypeData: [],
  isSalesRepTypeLoading: false,
  salesRepTypeFilters: {} as any,
  onSalesRepTypeSortingChange: (key: string, order: string) => {},
  handleSalesRepTypeReportDateChange: (startDate: any, endDate: any) => {},

  salesRepTypeEntityPerformanceChartData: [] as any,
  isSalesRepTypeEntityPerformanceChartDataLoading: false,
  onSalesRepTypeEntityPerformanceChartIdChange: (id: string) => {},
  onSalesRepTypeEntityPerformanceChartViewChange: (e: any) => {},
  onSalesRepTypeEntityPerformanceChartDateRangeChange: (startDate: any, endDate: any) => {},
  salesRepTypeEntityPerformanceChartFilters: {} as any,
})
